<template>
  <div class="product-gallery-container">
    <CustomGallery
      v-if="productImages.length > 0"
      :images="productImages"
      :enable-zoom="false"
      :outside-zoom="false"
      :product="product"
      class="product__gallery"
      :nuxt-img-config="{
        format: 'webp',
        fit: 'cover',
      }"
      :thumb-nuxt-img-config="{
        format: 'webp',
        fit: 'cover',
      }"
    />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import CustomGallery from '@/components/Catalog/Product/CustomGallery.vue';

export default defineComponent({
  name: 'ImageGallery',
  components: { CustomGallery },
  props: {
    productImages: {
      type: Array,
      default: () => [],
    },
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {},
});
</script>

<style lang="scss">
.product-gallery-container {
  width: 100%;
  .sf-gallery {
    --gallery-image-width: unset;
    --gallery-image-height: unset;
    --image-width: unset;
    --image-height: unset;
    flex-direction: column-reverse;
    @media (max-width: $tablet-max) {
      flex-direction: column;
    }
    width: 100%;
    &__thumbs {
      flex-direction: row;
      margin: 0;
      gap: 10px;
      padding: 10px;
      .sf-gallery__item {
        padding: 30px;
        aspect-ratio: 1/1;
        background: var(--c-white) 0% 0% no-repeat padding-box;
        box-shadow: 0 10px 35px var(--c-transparent-white);
        border-radius: 5px;
        max-width: calc(25% - 7px);
        @media (max-width: 1023px) {
          display: none;
        }
        img {
          height: auto;
          max-width: 5.625rem;
          max-height: 3.125rem;
        }
      }
    }
    &__stage {
      width: 100%;
      max-width: none;
      box-shadow: 0 10px 35px var(--c-transparent-white);
      border-radius: 15px;
      background: var(--c-white) 0% 0% no-repeat padding-box;
      margin-bottom: 10px;
      position: relative;
      aspect-ratio: 1/1;
      .glide__slides {
        li.glide__slide {
          aspect-ratio: 1/1;
          display: flex;
          justify-content: center;
          align-items: center;
          &:hover {
            pointer-events: none;
          }
          .sf-image--wrapper {
            max-width: 70%;
            display: flex;
            justify-content: center;
            align-items: center;
            .sf-image--overlay {
              display: none;
            }
            img {
              width: 100%;
              height: auto;
            }
            @media (max-width: 1023px) {
              width: 80%;
              height: 80%;
            }
            @media (max-width: 600px) {
              width: 70%;
              height: 70%;
            }
            @media (max-width: 390px) {
              width: 60%;
              height: 60%;
            }
          }
        }
      }
    }
  }
}
</style>
